import httpService from '@/services/httpService'

export const types = {
  ADD_PROJECT_DATA: 'project-settings/ADD_PROJECT_DATA',
  UPDATE_PROJECT_DATA: 'project-settings/UPDATE_PROJECT_DATA',
  ADD_IS_ACTIVE_OPTIONS: 'project-settings/ADD_IS_ACTIVE_OPTIONS',
  ADD_AGENCY_OPTIONS: 'project-settings/ADD_AGENCY_OPTIONS',
  ADD_TARGET_GEO_OPTIONS: 'project-settings/ADD_TARGET_GEO_OPTIONS',
  ADD_TARGET_DEVICE_OPTIONS: 'project-settings/ADD_TARGET_DEVICE_OPTIONS',
  ADD_TARGET_LOCALE_OPTIONS: 'project-settings/ADD_TARGET_LOCALE_OPTIONS',
  ADD_DATA_SOURCE_OPTIONS: 'project-settings/ADD_DATA_SOURCE_OPTIONS'
}
const emptyData = {
  projectData: {},
  isActiveOptions: [],
  agencyOptions: [],
  targetGeoOptions: [],
  targetDeviceOptions: [],
  targetLocaleOptions: [],
  dataSourceOptions: []
}
const state = { ...emptyData }

const mutations = {
  [types.ADD_PROJECT_DATA]: function (state, projectData) {
    state.projectData = projectData
  },
  [types.UPDATE_PROJECT_DATA]: function (state, projectData) {
    state.projectData = { ...state.projectData, ...projectData }
  },
  [types.ADD_IS_ACTIVE_OPTIONS]: function (state, isActiveOptions) {
    state.isActiveOptions = isActiveOptions
  },
  [types.ADD_AGENCY_OPTIONS]: function (state, agencyOptions) {
    state.agencyOptions = agencyOptions
  },
  [types.ADD_TARGET_GEO_OPTIONS]: function (state, targetGeoOptions) {
    state.targetGeoOptions = targetGeoOptions
  },
  [types.ADD_TARGET_DEVICE_OPTIONS]: function (state, targetDeviceOptions) {
    state.targetDeviceOptions = targetDeviceOptions
  },
  [types.ADD_TARGET_LOCALE_OPTIONS]: function (state, targetLocaleOptions) {
    state.targetLocaleOptions = targetLocaleOptions
  },
  [types.ADD_DATA_SOURCE_OPTIONS]: function (state, dataSourceOptions) {
    state.dataSourceOptions = dataSourceOptions
  }
}

const actions = {
  getProjectSettings: async function ({ commit }, clientId) {
    const response = await httpService.get(`/project-settings/${clientId}`)
    if (!response) {
      return
    }
    commit(types.ADD_PROJECT_DATA, response.data.project_data)
    commit(types.ADD_IS_ACTIVE_OPTIONS, response.data.is_active_options)
    commit(types.ADD_AGENCY_OPTIONS, response.data.agency_options)
    commit(types.ADD_TARGET_GEO_OPTIONS, response.data.target_geo_options)
    commit(types.ADD_TARGET_DEVICE_OPTIONS, response.data.target_device_options)
    commit(types.ADD_TARGET_LOCALE_OPTIONS, response.data.target_locale_options)
    commit(types.ADD_DATA_SOURCE_OPTIONS, response.data.data_source_options)
    return response
  },
// 'getShops', 'getClientShopData', 'updateClientShopData'
  getShops: async function ({ dispatch, commit }, { clientId, filterString = null }) {
    const response = await httpService.get(`/project-settings/shops/${clientId}`, {
      params: filterString ? { filter: filterString } : {}
    })
    return response.data
  },
  updateClientShopData: async function ({ dispatch, commit }, { clientId, ...params }) {
    const response = await httpService.patch(`/project-settings/shops/${clientId}`, params, { successMessage: 'Project settings updated successfully' })
    return response.data
  },
  changeProjectSettings: async function ({ dispatch, commit }, { clientId, ...params }) {
    const response = await httpService.patch(`/project-settings/change/${clientId}`, params, { successMessage: 'Project settings updated successfully' })
    if (!response) {
      return
    }
    commit(types.UPDATE_PROJECT_DATA, params)
    dispatch('rankZoneCommon/changeDiffScoreEnabled', params.difficulty_score_enabled, { root: true })
    dispatch('rankZoneCommon/changePublishingEnabled', params.publishing_enabled, { root: true })
    dispatch('rankZoneCommon/changeReportingLookbackMonths', params.reporting_lookback_months, { root: true })
    dispatch('rankZoneCommon/changeApiKeyEnabled', params.api_key_enabled, { root: true })
    dispatch('rankZoneCommon/changeWebhookEndpointEnabled', params.webhook_endpoint_enabled, { root: true })
    dispatch('rankZoneCommon/changeLinkBuildingReportEnabled', params.link_building_report_enabled, { root: true })
    return response.data.settings_updated
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
